"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaptureThumbnail = void 0;
var core_shared_1 = require("@ikegps/core-shared");
var theme_1 = require("../../components/theme");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var classnames_1 = require("../../util/classnames");
var hidden_image_icon_1 = require("../hidden.image.icon/hidden.image.icon");
var capture_thumbnail_style_1 = require("./capture.thumbnail.style");
(0, theme_1.addStyles)(capture_thumbnail_style_1.Style);
var DEFAULT_THUMBNAIL_SIZE = 180;
exports.CaptureThumbnail = {
    view: function (collection, capture, ctx) {
        var _a;
        if (ctx === void 0) { ctx = {}; }
        var draw = services_1.Services.DrawState.getIkeDraw(collection, capture.objectId);
        var className = (0, classnames_1.classNames)(capture_thumbnail_style_1.CSS.container, ctx.className, (_a = {},
            _a[capture_thumbnail_style_1.CSS.selectable] = typeof ctx.action === 'function',
            _a[capture_thumbnail_style_1.CSS.selected] = ctx.selected,
            _a[capture_thumbnail_style_1.CSS.hiddenCapture] = draw.state.imageVisibilityHidden,
            _a));
        var title = ctx.title;
        var onclick = ctx.action;
        var src = capture.thumbnail != null ? capture.thumbnail.url : capture.file.url;
        var size = {
            width: DEFAULT_THUMBNAIL_SIZE,
            height: DEFAULT_THUMBNAIL_SIZE
        };
        if (ctx.size) {
            size.width = ctx.size;
            size.height = ctx.size;
        }
        var renderCtx = {
            draw: draw,
            size: size,
            units: services_1.Services.UserSettings.units,
            isThumbnail: true,
            isInteractive: false,
            isEditable: false
        };
        return (0, mithril_1.m)('div', { className: className, title: title, onclick: onclick }, [
            (ctx.truesize || draw.state.brightness !== 1)
                ? (0, mithril_1.m)('div', { className: capture_thumbnail_style_1.CSS.overlay }, core_shared_1.SVGRenderer.view(renderCtx))
                : (0, mithril_1.m)('img', { className: capture_thumbnail_style_1.CSS.image, src: src }),
            ctx.crosshair && (0, mithril_1.m)('div', { className: capture_thumbnail_style_1.CSS.crosshair }),
            (ctx.truesize && ctx.icon) && (0, mithril_1.m)('div', { className: capture_thumbnail_style_1.CSS.photomeasure }),
            draw.state.imageVisibilityHidden && hidden_image_icon_1.HiddenImageIcon.view(),
            (0, mithril_1.m)('div', { className: capture_thumbnail_style_1.CSS.date }, services_1.Services.DateTime.formatDate(capture.collectedAt.iso))
        ]);
    }
};
//# sourceMappingURL=capture.thumbnail.js.map